import type { HelpFile } from '../../types/help'
import { CategoryPickerDialogTestIds } from '../../../testids/CategoryPickerDialogTestIds'

export const categoryPickerDialogHelp: HelpFile = {
  texts: {
    [CategoryPickerDialogTestIds.btnClearPickerSearch]: null,
    [CategoryPickerDialogTestIds.none]: 'Select this option to leave the category field empty.',
  },
}
